<template>
    <div class="columns">
        <div class="column">
            <div class="buttons">
                <a class="button" :href="urls.eventAdmin().exportEventRankingsAsCsv(store.eventId)">
                    <span class="icon">
                        <i class="fas fa-file-csv"></i>
                    </span>
                    <span>{{ translate("event_ranking.download_all_as_csv") }}</span>
                </a>
            </div>

            <div v-if="!initDone" class="is-flex is-justify-content-center">
                <LoadingSpinner2 />
            </div>
            <template v-else-if="rankingsListing.length > 0">
                <div class="box" v-for="ranking in rankingsListing" :key="ranking.name">
                    <div class="is-flex is-align-items-center">
                        <div class="is-size-5 is-flex-grow-1">
                            {{ ranking.name }}
                            <div class="is-size-7">
                                {{ autoConvertToTimezone(ranking.created) }}
                            </div>
                        </div>

                        <div class="buttons">
                            <a class="button is-small" :href="urls.eventAdmin().exportSingleEventRankingAsCsv(store.eventId, ranking.id)">
                                <span class="icon">
                                    <i class="fas fa-file-csv"></i>
                                </span>
                                <span>{{ translate("common.download_in_csv") }}</span>
                            </a>
                            <LoadingButton
                                :is-loading="deleteInProgress === ranking.id"
                                class="button is-danger is-small"
                                @click="deleteRanking(ranking.id)"
                            >
                                <span class="icon">
                                    <i class="fas fa-times"></i>
                                </span>
                                <span>{{ translate("common.delete") }}</span>
                            </LoadingButton>
                        </div>
                    </div>

                    <hr />

                    <GeneratedRankingTable :generated-ranking="ranking" />
                </div>
            </template>
            <Notification v-else class="is-info is-size-5">
                {{ translate("event_ranking.no_saved_rankings_available") }}
            </Notification>
        </div>
    </div>
</template>

<script setup lang="ts">
    import eventRankingsApi, { SavedEventRanking } from "../Api/eventRankings";
    import { onMounted, ref } from "vue";
    import { useEventRankingsStore } from "./eventRankingsStore";
    import GeneratedRankingTable from "./GeneratedRankingTable.vue";
    import { autoConvertToTimezone } from "../Common/dateTimeUtils";
    import { handleError } from "../Common/errorHandler";
    import LoadingButton from "../Common/LoadingButton.vue";
    import { successToast } from "../Common/toasts";
    import Notification from "../Common/Notification.vue";
    import { translate } from "../Common/translations";
    import LoadingSpinner2 from "../Common/LoadingSpinner2.vue";
    import urls from "../Urls/urls";

    const store = useEventRankingsStore();
    const rankingsListing = ref<SavedEventRanking[]>([]);
    const initDone = ref(false);

    onMounted(() => {
        initDone.value = false;
        return eventRankingsApi
            .getListing(store.eventId)
            .then(listing => {
                rankingsListing.value = listing;
            })
            .catch(handleError)
            .finally(() => {
                initDone.value = true;
            });
    });

    // DELETE RANKING

    const deleteInProgress = ref<number>(0);

    function deleteRanking(id: number) {
        deleteInProgress.value = id;
        return eventRankingsApi
            .deleteSavedRanking(store.eventId, id)
            .then(() => {
                rankingsListing.value = rankingsListing.value?.filter(ranking => ranking.id !== id);
                successToast(translate("event_ranking.ranking_deleted"));
            })
            .catch(handleError)
            .finally(() => {
                deleteInProgress.value = 0;
            });
    }
</script>

<style scoped></style>
